export default __webpack_public_path__ + "13f92c72aac5f4761727bc3318a52a6a.png";